// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e65fbcd5","84":"22ef0355","247":"982867de","440":"6d50dc1f","453":"19de56ef","627":"5474222b","738":"fab90171","834":"3f602c23","923":"ad6985e2","938":"f86a5339","963":"a732071d"}[chunkId] + ".chunk.js";
};